<template>
  <b-container>
    <CalendarList></CalendarList>
    <EventList></EventList>
  </b-container>
</template>

<script>
import EventList from '@/components/Calendar/Event/EventList'
import CalendarList from '@/components/Calendar/Calendar/CalendarList'
export default {
  name: 'CalendarIndex',
  components: { CalendarList, EventList }
}
</script>

<style scoped>

</style>
